import React from 'react';
import './services.css';
import { BsCheckAll } from 'react-icons/bs';
import { BiCheck } from 'react-icons/bi';
const Services = () => {
  return (
    <section id='services'>
      <h5>What I Offer</h5>
      <h2>Services</h2>

      <div className='container services__container'>
        <article className='service'>
          <div className='service__head'>
            <h3>UI/UX Design</h3>
          </div>
          <ul className='service__list'>
            <li>
              <BiCheck className='service__list-icons' />
              <p>Photo editing using Adobe Photoshop</p>
            </li>
            <li>
              <BiCheck className='service__list-icons' />
              <p>Creating Designs using Adobe Illustrator</p>
            </li>
            <li>
              <BiCheck className='service__list-icons' />
              <p>UI/UX using Figma</p>
            </li>
            <li>
              <BiCheck className='service__list-icons' />
              <p>Used Canva for some Basic Designs</p>
            </li><li>
              <BiCheck className='service__list-icons' />
              <p>System Design and Flow Chart using Lucid Chart</p>
            </li>
            {/*
            <li>
              <BiCheck className='service__list-icons' />
              <p>Lorem, ipsum dolor sit amet consctetur elit.</p>
            </li>
            <li>
              <BiCheck className='service__list-icons' />
              <p>Lorem, ipsum dolor sit amet consctetur elit.</p>
            </li>
            <li>
              <BiCheck className='service__list-icons' />
              <p>Lorem, ipsum dolor sit amet consctetur elit.</p>
            </li>
            */}
          </ul>
        </article>
        { /*End of UI/UX */}
        <article className='service'>
          <div className='service__head'>
            <h3>Web Development</h3>
          </div>
          <ul className='service__list'>
            <li>
              <BiCheck className='service__list-icons' />
              <p>Front-End using HTML, CSS</p>
            </li>
            <li>
              <BiCheck className='service__list-icons' />
              <p>Front-End using ReactJs and NextJs</p>
            </li>
            <li>
              <BiCheck className='service__list-icons' />
              <p>Back-End using NodeJs, JavaScript and TypeScript</p>
            </li>
            <li>
              <BiCheck className='service__list-icons' />
              <p>Handeling Database like MongoDB, SQL</p>
            </li>
            <li>
              <BiCheck className='service__list-icons' />
              <p>Cloud Hosting Services such as AWS, Google Cloud</p>
            </li>
          </ul>
        </article>
        {/* End of Web Development */}

        {/*
          <article className='service'>
          <div className='service__head'>
            <h3>Multilanguage Enthusiast</h3>
          </div>
          <ul className='service__list'>
            <li>
              <BiCheck className='service__list-icons' />
              <p>Data Structure and Algorithms using C++</p>
            </li>
            <li>
              <BiCheck className='service__list-icons' />
              <p>Intermediate Python Developer and it's libraries like </p>
            </li>
            <li>
              <BiCheck className='service__list-icons' />
              <p>Knowledge of JavaScript</p>
            </li>
          </ul>
          </article> */}
        {/* End of Content Creation */}
      </div>
    </section>
  )
}

export default Services